import React from 'react';
import * as styles from './style';
import CreateCategory from './CreateCategory';
import SearchProduct from './SearchProduct';

export const ProductsSecondaryActions = ({
  refreshProductsList,
  insertCategoryInProductsList,
  filterCategories,
  categories,
}) => {
  return (
    <styles.Container>
      <styles.Content>
        <CreateCategory
          refreshProductsList={refreshProductsList}
          insertCategoryInProductsList={insertCategoryInProductsList}
        />
        <SearchProduct categories={categories} filterCategories={filterCategories} />
      </styles.Content>
    </styles.Container>
  );
};

export default ProductsSecondaryActions;



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsSecondaryActions/index.js